module.exports = __webpack_public_path__ + "img/sum-bet-btn.e41f5c16.svg";